import img_checked from '@/assets/img/img_checked.png';
import img_uncheck from '@/assets/img/img_uncheck_v2.png';
import img_checked_notall from '@/assets/img/img_checked_notall.png';
import { useState } from 'react';
import { useCallback } from 'react';
import { useEffect } from 'react';

const CheckBox = ({
  className,
  style,
  server_list,
  value,
  onPassChencked,
  onClickAll,
  indeterminate = false,
  passChecked = false
}) => {
  const [checked, setChecked] = useState(passChecked);

  const onChecked = useCallback(() => {
    setChecked(!checked)
    onPassChencked(!checked)
  }, [checked])

  useEffect(() => {
    setChecked(passChecked)
  }, [passChecked])

  return (
    <span  onClick={onChecked} className={`${className} cursor-pointer`} style={style}>
      {indeterminate ? (
        <img
          className="w-16px mr-12px"
          src={img_checked_notall}
        />
      ) : (
        <img
          // onClick={onChecked}
          className="w-16px mr-12px"
          src={checked ? img_checked : img_uncheck}
        />
      )}
    </span>
  );
};

export default CheckBox;
